import React, { useState, useEffect } from "react";
import Wrapper from "../Wrapper/Wrapper";
import Button from "../Button/Button";
import NewsLetterPopup from "../Popup/NewsLetterPopup";

function Newsletter({ data }) {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (isOpen && typeof document !== `undefined`) {
      document.body.style.overflow = "hidden";
    }

    return () => (document.body.style.overflow = "scroll");
  }, [isOpen]);

  return (
    <Wrapper>
      <h2 className="text-4xl text-black text-center xs:font-cairo font-semibold pb-5">
        {/* {data.title} */}
        Subscribe our newsletter for latest updates of blogs
      </h2>
      {/* {data} */}
      <div className="flex flex-col sm:flex-row gap-4 px-5 sm:px-0  justify-center">
        <Button
          variant="primary"
          title="Subscribe Now"
          onClick={() => setIsOpen(true)}
        />
        <Button variant="outlined" title="View Our latest" link="/blog" />
      </div>
      <NewsLetterPopup isOpen={isOpen} setIsOpen={setIsOpen} />
    </Wrapper>
  );
}
export default Newsletter;
